module.exports = __webpack_public_path__ + "static/media/nh-icon-csr.e3bd4c82.png";